const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPedestrian(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.79885,
    height: 52.68145,
    viewBox: "0 0 25.79885 52.68145",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "b749db3f-eb30-4790-92c5-06cf8813f543",
    "data-name": "Ebene 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b10b2870-96e9-4882-8adb-98c68e47e3e8",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bc43a3d8-3f30-4a29-8c56-03ffe398b7a9",
    "data-name": "Trafficon-Icon-6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b50539ac-e3e0-4470-9d77-4081362dfb2b",
    "data-name": "icon-ped-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "b14f03fd-09f1-43f2-a691-0bdaccb4dd0d",
    "data-name": "Pfad 730",
    d: "M8.67543,12.5534a5.77535,5.77535,0,0,0,5.76284-5.78768l0-.00275h0A5.7766,5.7766,0,1,0,2.8851,6.79044h0a5.77045,5.77045,0,0,0,5.78033,5.75045h0Z",
    style: {
      fill: "none",
      stroke: "#3a3a3a",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a8144889-8ec7-4d30-9efc-9a93b8875c82",
    "data-name": "Pfad 930",
    d: "M24.79885,27.84283h0A11.90063,11.90063,0,0,0,12.8982,15.94213h0",
    style: {
      fill: "none",
      stroke: "#3a3a3a",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "be394d4c-a324-4705-959b-8a6c1b0f7507",
    "data-name": "Pfad 931",
    d: "M18.84851,33.79043h0c-6.27036,0-11.34565,8.00033-11.34565,17.891h0",
    style: {
      fill: "none",
      stroke: "#3a3a3a",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "bdac6e66-b2f8-40e6-a093-4ba740f36bca",
    "data-name": "Pfad 932",
    d: "M1,27.84283H1a11.90069,11.90069,0,0,0,11.89817-11.9007h0",
    style: {
      fill: "none",
      stroke: "#3a3a3a",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    id: "a36a7f9f-9ba5-44b3-9d78-eaddb6a1b085",
    "data-name": "Linie 142",
    x1: 12.89567,
    y1: 15.94453,
    x2: 24.79634,
    y2: 51.64154,
    style: {
      fill: "none",
      stroke: "#3a3a3a",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPedestrian);
export default __webpack_public_path__ + "static/media/Pedestrian.4e793582701924d1043e321cd66b2ca5.svg";
export { ForwardRef as ReactComponent };